/* eslint-disable */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, BaseSelect } from 'ui-kit';
import { BUTTON_TYPES } from '_constants';
import * as Styled from '../styles';
import * as Styles from './styles';

function ExportDirectionModal({ isOpen, onClose, urls, waypoints }) {
  const handleLink = (url) => {
    window.open(url, '_blank');
  };

  const handleCopyLinks = async () => {
    // to do
  };

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Styled.ModalWrapper>
        <Styled.ModalTitle>
          Google's maximum limit is 11 waypoints, so we split your route into {urls.length} parts
        </Styled.ModalTitle>

        <Styles.ListsContainer>
          {waypoints.map((waypoint, index) => (
            <Styles.ListWrapper key={index}>
              <div style={{ display: 'flex', justifyContent: 'start', alignItems: 'baseline' }}>
                <Styled.ModalTitle>Part {index + 1}</Styled.ModalTitle>
                <Styles.LinkButton onClick={() => handleLink(urls[index])}>Export</Styles.LinkButton>
              </div>
              <Styles.List>
                {waypoint.map((el) => (
                  <li>{el?.address}</li>
                ))}
              </Styles.List>
            </Styles.ListWrapper>
          ))}
        </Styles.ListsContainer>

        {/* <Styles.ModalButtonWrapper>
          <Styled.ModalButtonCancel
            onClick={handleCopyLinks}
            // text={isCopying ? 'Copying...' : copySuccess ? 'Copied!' : 'Copy All Links'}
            // disabled={isCopying}
            variant={BUTTON_TYPES.DARK}
            aria-label="Copy all links"
          />
        </Styles.ModalButtonWrapper> */}
      </Styled.ModalWrapper>
    </Modal>
  );
}

ExportDirectionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  urls: PropTypes.array,
  waypoints: PropTypes.array,
};

ExportDirectionModal.defaultProps = {
  urls: [],
  waypoints: [],
};

export default ExportDirectionModal;
